import { Col, DatePicker, Form, Input, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import dayjs from 'dayjs';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const Edit = (props: any) => {
    const apiId = 'dbTables';
    const ref = useRef<any>(undefined);
    const [form] = Form.useForm();
    const { defaultService, sendPageData } = props;
    const [dbBackupsData, setDbBackupsData] = useState<any>();
    const [databaseData, setDatabaseData] = useState();
    const [sourceTableData, setSourceTableData] = useState();
    const [targetTableData, setTargetTableData] = useState();
    const [dataConflictResolutionData, setDataConflictResolutionData] = useState();
    const [specialDataDisabled, setSpecialDataDisabled] = useState<boolean>(true);

    // 把 dbBackupsId 同步到表单属于副作用，必须放在 useEffect 中，不能直接写在渲染阶段
    useEffect(() => {
        if (sendPageData) {
            const { dbBackupsId } = sendPageData;
            form.setFieldValue('dbBackupsId', dbBackupsId);
        }
    }, [sendPageData, form]);

    /**
     * 获取库中所有数据表
     * @param options 选项
     */
    const getTableNamesFromDB = (options: {
        databaseName: string,
        serviceUrl: string,
        type?: 'source' | 'target'
    }) => {
        const { databaseName, serviceUrl, type = 'source' } = options;
        fetchApi.GET(serviceUrl,
            {
                query: {
                    apiId: 'dbTables',
                    apiExtend: 'getTableNamesFromDB',
                    apiData: JSON.stringify({
                        databaseName
                    })
                }
            }).then(res => {
                if (res?.success === true) {
                    if (type === 'target') {
                        setTargetTableData(res.data);
                    } else {
                        setSourceTableData(res.data);
                    }
                }
            })
    };

    useEffect(() => {
        if (ref.current) {
            ref.current.getRow?.then((res: any) => {
                if (res?.success === true) {
                    const { sourceDatabase, targetDatabase, isDeleteSpecialDataFromTheSourceTable } = res.data;
                    getTableNamesFromDB({
                        serviceUrl: defaultService,
                        databaseName: sourceDatabase
                    })
                    getTableNamesFromDB({
                        serviceUrl: defaultService,
                        databaseName: targetDatabase,
                        type: 'target'
                    })
                    setSpecialDataDisabled(!isDeleteSpecialDataFromTheSourceTable);
                }
            })
        }
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'dbBackups',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success === true) {
                    setDbBackupsData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'database@dBBackupsDataConflictResolution',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { database, dBBackupsDataConflictResolution } = res.data;
                    setDatabaseData(database);
                    setDataConflictResolutionData(dBBackupsDataConflictResolution);
                }
            })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        displayOptions: {
            width: 700
        },
        dateOptions: {
            columnNames: ['pointInTime'],
            timeColumnNames: ['pointInTime']
        },
        formOptions: {
            instance: form,
            children: (
                <Row >
                    <Col span={12}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="数据库备份"
                            name="dbBackupsId">
                            <Select
                                disabled={true}
                                placeholder="数据库系统"
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(dbBackupsData, {
                                    itemName: 'backupName'
                                })} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="源数据库"
                            name="sourceDatabase"
                            rules={[{ required: true, message: '请选择源数据库!' }]}>
                            <Select
                                placeholder="源数据库"
                                onChange={e => {
                                    getTableNamesFromDB({
                                        databaseName: e,
                                        serviceUrl: defaultService
                                    });
                                }}
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(databaseData)} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="源表"
                            name="sourceTableId"
                            rules={[{ required: true, message: '请选择源表!' }]}>
                            <Select
                                placeholder="请选择源表"
                                style={{ width: 275 }}
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(sourceTableData)} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="目标数据库"
                            name="targetDatabase"
                            rules={[{ required: true, message: '请选择目标数据库!' }]}>
                            <Select
                                placeholder="目标数据库"
                                onChange={e => {
                                    getTableNamesFromDB({
                                        databaseName: e,
                                        serviceUrl: defaultService,
                                        type: 'target'
                                    });
                                }}
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(databaseData)} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="目标表"
                            name="targetTableId"
                            rules={[{ required: true, message: '请选择目标表!' }]}>
                            <Select
                                placeholder="请选择目标表"
                                style={{ width: 260 }}
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(targetTableData)} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="冲突解决"
                            name="dataConflictResolutionId"
                            tooltip='数据备份时冲突的解决方案'>
                            <Select
                                placeholder="数据冲突解决"
                                showSearch={{
                                    optionFilterProp: 'label',
                                    filterOption: (input, option: any) =>
                                        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }}
                                options={getList.general2(dataConflictResolutionData, { includeNull: true })} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="冲突主键"
                            tooltip='数据冲突解决主键，如不填，默认："id"'
                            name="primaryKey">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="N天前"
                            name="backupDaysBefore"
                            tooltip='备份N天前数据'
                            rules={[{ required: true, message: '请输入数字!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="时间点"
                            name="pointInTime">
                            <DatePicker picker="time" format="HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="关键字"
                            tooltip='查询备份N天前数据的关键字，如不填，默认："createdAt"'
                            name="backupDaysColumnName">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={20}>
                        <Form.Item
                            label="父表依赖关系"
                            tooltip="所依赖的父表及外键关系，格式：表名@外键字段名，多个用逗号分隔。例如：父表名1@外键字段名1,父表名2@外键字段名2,..."
                            name="parentDependencies">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="排序"
                            name="sortBy"
                            tooltip='父表排前，子表排后'>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="过滤语句"
                            tooltip="如有需要，可以附加过滤源表数据的SqlWhere语句，例如：a = 'a'"
                            name="sqlWhere">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="删除源表特别数据"
                            tooltip='根据备份条件及特别数据的SqlWhere删除源表特别数据，不可恢复'
                            name="isDeleteSpecialDataFromTheSourceTable"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch
                                onChange={e => { setSpecialDataDisabled(!e); }}
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={17}>
                        <Form.Item
                            label="特别数据的SqlWhere"
                            tooltip="删除源表特别数据的SqlWhere语句，例如：a = 'a'"
                            name="deleteSpecialDataSqlWhere">
                            <Input disabled={specialDataDisabled} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="删除源数据"
                            tooltip='删除源表数据，不可恢复'
                            name="isDeleteSourceTableData"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="检查结构"
                            name="isCheckStructureMatch"
                            tooltip='检查源表与目标表结构是否匹配'
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="禁用外键约束"
                            name="isDisableForeignKeyConstraints"
                            tooltip='禁用外键约束'
                            valuePropName="checked"
                            initialValue={false}>
                            < Switch
                                checkedChildren="是"
                                unCheckedChildren="否" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default Edit;